// auth stream: sign-in page and session messages.
export const en: Record<string, string> = {
  "signin.title": "Sign in",
  "signin.private": "Private demo. Access is by invitation from the agency or from 10x.",
  "signin.name": "Your name",
  "signin.email": "Work email",
  "signin.code": "Access code",
  "signin.codeHelp": "The code you received with your invitation.",
  "signin.submit": "Enter the workspace",
  "signin.working": "Checking…",
  "signin.error.code": "That access code was not recognized.",
  "signin.error.generic": "Could not sign you in.",
  "signin.error.inactive": "Your staff record is inactive. Ask the agency owner to reactivate it.",
  "signin.dev": "Local development build: no sign-in needed. Pick a user in Settings.",
  "signin.devGo": "Open the workspace",
  "signin.clerkMissing": "Clerk is selected for this deployment but the publishable key is not set.",
  "signin.sessionKept": "You stay signed in on this device for 12 hours.",
  "signin.language": "Language",
  "session.signOut": "Sign out",
  "session.signedInAs": "Signed in as",
};

export const es: Record<string, string> = {
  "signin.title": "Iniciar sesión",
  "signin.private": "Demostración privada. El acceso es por invitación de la agencia o de 10x.",
  "signin.name": "Su nombre",
  "signin.email": "Correo de trabajo",
  "signin.code": "Código de acceso",
  "signin.codeHelp": "El código que recibió con su invitación.",
  "signin.submit": "Entrar al espacio de trabajo",
  "signin.working": "Verificando…",
  "signin.error.code": "Ese código de acceso no fue reconocido.",
  "signin.error.generic": "No se pudo iniciar sesión.",
  "signin.error.inactive": "Su registro de personal está inactivo. Pida al dueño de la agencia que lo reactive.",
  "signin.dev": "Versión de desarrollo local: no requiere inicio de sesión. Elija un usuario en Configuración.",
  "signin.devGo": "Abrir el espacio de trabajo",
  "signin.clerkMissing": "Clerk está seleccionado para este despliegue pero falta la clave publicable.",
  "signin.sessionKept": "Permanece conectado en este dispositivo por 12 horas.",
  "signin.language": "Idioma",
  "session.signOut": "Cerrar sesión",
  "session.signedInAs": "Sesión iniciada como",
};
